import { voucherService } from "@/services/VoucherService";
import { toast } from "vue3-toastify";
import { i18n } from "./../lang";

const state = {
    vouchers: [],
    isCreatingVouchers: false,
    editingVoucher: null,
    lastCreatedVouchers: [],
    redemptions: [],
    getVouchersRequest: {
        loading: false
    },
    createVouchersRequest: {
        loading: false
    },
    editVoucherRequest: {
        loading: false
    },
    deleteVoucherRequest: {
        loading: false
    },
    redemptionsRequest: {
        loading: false
    },
    pdfRequest: {
        loading: false
    }
}

const actions = {
    getVouchers({commit}) {
        commit('setGetVouchersRequest', {loading: true});
        voucherService.getVouchers()
            .then((response) => {
                commit('setGetVouchersRequest', {loading: false});
                commit('setVouchers', response.data || []);
            })
            .catch((error) => commit('setGetVouchersRequest', {loading: false, message: error}));
    },
    createVouchers({commit, state}, voucher) {
        commit('setCreateVouchersRequest', {loading: true});
        return voucherService.createVouchers(voucher)
            .then((response) => {
                const created = response.data || [];
                toast.success(i18n.global.t("toast.createSuccess"));
                commit('setVouchers', [...created, ...state.vouchers]);
                commit('setLastCreatedVouchers', created);
                commit('setCreateVouchersRequest', {loading: false});
                return created;
            })
            .catch((error) => {
                toast.error(error || i18n.global.t("toast.createError"));
                commit('setCreateVouchersRequest', {loading: false, message: error});
            });
    },
    updateVoucher({commit, state}, {voucherId, voucher}) {
        commit('setEditVoucherRequest', {loading: true});
        return voucherService.updateVoucher(voucherId, voucher)
            .then((response) => {
                const updated = response.data;
                toast.success(i18n.global.t("toast.successEdit"));
                commit('setVouchers', state.vouchers.map(item =>
                    item.voucherId === voucherId ? updated : item
                ));
                commit('setEditVoucherRequest', {loading: false});
                commit('setEditingVoucher', null);
                return updated;
            })
            .catch((error) => {
                toast.error(error || i18n.global.t("toast.errorEdit"));
                commit('setEditVoucherRequest', {loading: false, message: error});
            });
    },
    deleteVoucher({commit, state}, voucherId) {
        commit('setDeleteVoucherRequest', {loading: true});
        return voucherService.deleteVoucher(voucherId)
            .then(() => {
                toast.success(i18n.global.t("toast.deleteSuccess"));
                commit('setVouchers', state.vouchers.filter(item => item.voucherId !== voucherId));
                commit('setDeleteVoucherRequest', {loading: false});
                commit('setEditingVoucher', null);
            })
            .catch((error) => {
                toast.error(error || i18n.global.t("toast.deleteError"));
                commit('setDeleteVoucherRequest', {loading: false, message: error});
            });
    },
    getVoucherRedemptions({commit}, voucherId) {
        commit('setRedemptionsRequest', {loading: true});
        commit('setRedemptions', []);
        voucherService.getVoucherRedemptions(voucherId)
            .then((response) => {
                commit('setRedemptions', response.data || []);
                commit('setRedemptionsRequest', {loading: false});
            })
            .catch((error) => commit('setRedemptionsRequest', {loading: false, message: error}));
    },
    downloadVouchersPdf({commit}, voucherIds) {
        if (!voucherIds || voucherIds.length === 0) return;
        commit('setPdfRequest', {loading: true});
        return voucherService.downloadVouchersPdf(voucherIds)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response], {type: 'application/pdf'}));
                const link = document.createElement('a');
                link.href = url;
                link.download = `vouchers-${Date.now()}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                commit('setPdfRequest', {loading: false});
            })
            .catch((error) => {
                toast.error(i18n.global.t("voucherPageStrings.errorPdf"));
                commit('setPdfRequest', {loading: false, message: error});
            });
    }
}

const mutations = {
    setVouchers(state, vouchers) {
        state.vouchers = vouchers;
    },
    setRedemptions(state, redemptions) {
        state.redemptions = redemptions;
    },
    setEditingVoucher(state, voucher) {
        state.editingVoucher = voucher;
        if (voucher) state.isCreatingVouchers = false;
    },
    setIsCreatingVouchers(state, isCreating) {
        state.isCreatingVouchers = isCreating;
        if (isCreating) state.editingVoucher = null;
    },
    setLastCreatedVouchers(state, vouchers) {
        state.lastCreatedVouchers = vouchers;
    },
    setGetVouchersRequest(state, {loading, message}) {
        state.getVouchersRequest = {loading, message};
    },
    setCreateVouchersRequest(state, {loading, message}) {
        state.createVouchersRequest = {loading, message};
    },
    setEditVoucherRequest(state, {loading, message}) {
        state.editVoucherRequest = {loading, message};
    },
    setDeleteVoucherRequest(state, {loading, message}) {
        state.deleteVoucherRequest = {loading, message};
    },
    setRedemptionsRequest(state, {loading, message}) {
        state.redemptionsRequest = {loading, message};
    },
    setPdfRequest(state, {loading, message}) {
        state.pdfRequest = {loading, message};
    }
}

export const voucher = {
    namespaced: true,
    state,
    actions,
    mutations,
}
